import Procurement from "./Procurement/Procurement";
import Network from "./network/Network";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import ManagePo from "./Procurement/ManagePO";
import { Helmet } from "react-helmet";
import Shipment from "./shipment/Shipment";
import ShipmentShow from "./shipment/ShipmentShow";
import NewDashboardLayout from "component/layout/NewDashboardLayout";

const Flex = () => {
    const { pathname } = useLocation();
    const mainRef = useRef();
    const loadedPoDataRef = useRef({});
    const navigate = useNavigate();
    const routes = [
        "/flex/home",
        "/flex/home/network",
        "/flex/home/manage-po",
        "/flex/home/shipments",
        "/flex/home/manage-shipment",
    ];

    useEffect(() => {
        mainRef.current.scroll({ top: 0, behavior: "smooth" });
    });
    useEffect(() => {
        !routes.includes(pathname) && navigate("/flex/home");
    }, [pathname]);

    return (
        <NewDashboardLayout>
            <Helmet>
                <title>Tradevu — flex</title>
            </Helmet>
                <div className="flex h-[calc(100%-80px)]">
                    <main className="w-full" ref={mainRef}>
                        {pathname === "/flex/home" && (
                            <Procurement loadedPoDataRef={loadedPoDataRef} />
                        )}
                        {pathname === "/flex/home/network" && <Network />}
                        {pathname === "/flex/home/manage-po" && <ManagePo />}
                        {pathname === "/flex/home/manage-shipment" && (<ShipmentShow />)}
                        {pathname === "/flex/home/shipments" && <Shipment />}
                    </main>
                </div>
        </NewDashboardLayout>
    );
};

export default Flex;
